import React from 'react'

function Footer() {
    return (
        <div id="rs-footer" className="rs-footer style4">
            <div className="" style={{width: '90%', margin: 'auto'}}>
                <div className="footer-content pt-62 pb-79 md-pb-64 sm-pt-48">

                </div>
                <div className="footer-bottom">
                    <div className="row y-middle">
                        <div className="col-lg-6 col-md-8 sm-mb-21">
                            <div className="copyright">
                                <p>© Copyright 2021 Reobiz. All Rights Reserved.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-4 text-right sm-text-center">
                            <ul className="footer-social">
                                <li><a href="#"><i className="fa fa-facebook"></i></a></li>
                                <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                                <li><a href="#"><i className="fa fa-pinterest-p"></i></a></li>
                                <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
